import styled from '@emotion/styled'
import { containers } from 'style';

const Spacer200 = styled.div`
    background-color: ${props =>
    props.backgroundColor ? props.backgroundColor.hex : ''};
    min-height: 64px;
    height: ${100 / 18 * 3}vw;
    // height: ${100 / 18 * 4}vw;
    @media (min-width: ${containers.ipad}px) {
      height: ${100 / 18 * 2}vw;
    }
    width: 100%;
    margin-top: -1px;
`;

export default Spacer200;
